<template>
  <div>
    <Dashboard />
    <section id="content">
      <div class="container">
        <ListHeaderTool
          @dateFilter="dateFilter"
          @filterType="filterType"
          :dviptype="dvip_TYPE"
        ></ListHeaderTool>
      </div>
      <div class="container" id="content-item">
        <ListHeader :memberActivePoint="memberActivePoint" />
        <FetchData
          :transactions="transactions"
          @openModal="openModal"
          :memberActivePoint="memberActivePoint"
        ></FetchData>
        <Loader :class="{ marinTop: mTop }" v-if="loader" />
        <Pagination
          :totalPage="totalPage"
          :selectTransactionType="selectTransactionType"
          :pageIndex="pageIndex"
          @fetchData="fetchData"
        ></Pagination>
      </div>
      <transition name="fade">
        <Modal
          :show="showModal"
          :iscoin="iscoin"
          :itemData="modalData"
          @hideModal="closeModal"
          :headerData="headerData"
        ></Modal>
      </transition>
      <transition name="fade">
        <Error
          :errorMessage="errorMessage"
          v-if="errorModal"
          @hideErrorMessage="hideErrorMessage"
        ></Error>
      </transition>
    </section>
  </div>
</template>

<script>
import Modal from "@/components/transaction/ModalMember";
import Dashboard from "@/views/layout/Dashboard";
import Loader from "@/views/plugin/loader";
import Pagination from "@/views/plugin/pagination";
import Error from "@/views/plugin/error";
import FetchData from "./FetchData";
import ListHeaderTool from "./ListHeaderTool";
import ListHeader from "./ListHeader";
import EventBus from "@/EventBus.js";
import { Member } from "@/mixins/Member";
export default {
  mixins: [Member],
  data() {
    return {
      transactions: {},
      modalData: [],
      headerData: {},
      pageIndex: "",
      errorMessage: "",
      totalPage: "",
      newStartDate: "",
      newEndDate: "",
      selectTransactionType: "",
      showModal: false,
      loader: true,
      errorModal: false,
      mTop: false,
      iscoin: false,
      memberActivePoint: false,
      dvip_TYPE: false,
    };
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    hideErrorMessage() {
      (this.errorMessage = ""), (this.errorModal = false);
    },
    scrollToTop() {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
    hideMenu() {
      EventBus.$emit("MOBILE_MENU_HIDE");
    },
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    checkUser() {
      var tokenId = localStorage.getItem("authToken");
      if (tokenId == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/info/token`,
          // `card/info`,
          { tokenId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            if (result.isDVIP === 0) {
              this.$router.push({ name: "transaction" });
            }
            if (result.dvip_TYPE == "A") {
              this.dvip_TYPE = false;
            } else {
              this.dvip_TYPE = true;
            }
          } else if (result.status === 201) {
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          }
        })
        .catch((error) => {
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
  },
  created() {
    this.checkUser();
    this.fetchData();
    this.hideMenu();
  },
  components: {
    Modal,
    Dashboard,
    Loader,
    Pagination,
    FetchData,
    Error,
    ListHeaderTool,
    ListHeader,
  },
};
</script>

<style>
.marinTop {
  margin-top: 10%;
}
</style>
